import type {RouteRecordRaw} from 'vue-router';

export const clientPageRoutes: Array<RouteRecordRaw> = [];
